(function () {
  "use strict";

  function initRoot(root) {
    if (!root || root.dataset.wtReady === "1") return;
    root.dataset.wtReady = "1";

    var apiBase = (root.getAttribute("data-api-base") || "").replace(/\/+$/, "");
    var form = root.querySelector("[data-warranty-form]");
    var brandSelect = root.querySelector("[data-brand-select]");
    var messageEl = root.querySelector("[data-message]");
    var submitBtn = root.querySelector("[data-submit]");
    var showPhone = root.getAttribute("data-show-phone") === "true";
    var requireSerial = root.getAttribute("data-require-serial") === "true";
    var orderLookupEnabled = root.getAttribute("data-order-lookup") === "true";

    if (!form || !apiBase) {
      showMessage(messageEl, "error", "This form is not configured yet. Set the backend URL in the theme editor.");
      return;
    }

    // Optional fields visibility / requirements.
    var phoneField = root.querySelector("[data-phone-field]");
    if (phoneField) phoneField.hidden = !showPhone;
    if (requireSerial) {
      var serial = form.querySelector('[name="serialNumber"]');
      if (serial) {
        serial.setAttribute("required", "required");
        var lbl = root.querySelector("[data-serial-field] label");
        if (lbl && lbl.textContent.indexOf("*") === -1) lbl.textContent = "Serial number *";
      }
    }

    // Prevent future purchase dates.
    var dateInput = form.querySelector('[name="purchaseDate"]');
    if (dateInput) dateInput.max = new Date().toISOString().slice(0, 10);

    loadBrands(apiBase, brandSelect, messageEl);
    if (orderLookupEnabled) initOrderLookup(apiBase, root, form);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      submit(apiBase, root, form, messageEl, submitBtn);
    });
  }

  function loadBrands(apiBase, select, messageEl) {
    if (!select) return;
    fetch(apiBase + "/api/brands", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        var brands = (data && data.brands) || [];
        select.innerHTML = "";
        var first = document.createElement("option");
        first.value = "";
        first.textContent = brands.length ? "Select a brand…" : "No brands available";
        select.appendChild(first);
        brands.forEach(function (b) {
          var opt = document.createElement("option");
          opt.value = b.id;
          opt.textContent = b.name;
          select.appendChild(opt);
        });
      })
      .catch(function () {
        select.innerHTML = '<option value="">Could not load brands</option>';
        showMessage(messageEl, "error", "We couldn't reach the warranty service. Please try again later.");
      });
  }

  // "Find my order": verify the order number + email against Shopify and auto-fill
  // the product + purchase date. Purely additive — manual entry still works if this
  // is disabled, unavailable, or fails.
  function initOrderLookup(apiBase, root, form) {
    var ui = root.querySelector("[data-lookup-ui]");
    var btn = root.querySelector("[data-lookup-btn]");
    var statusEl = root.querySelector("[data-lookup-status]");
    var orderInput = form.querySelector('[name="orderNumber"]');
    var emailInput = form.querySelector('[name="customerEmail"]');
    var verifiedInput = form.querySelector('[name="orderVerified"]');
    var orderIdInput = form.querySelector('[name="shopifyOrderId"]');
    var els = {
      orderInput: orderInput,
      emailInput: emailInput,
      dateInput: form.querySelector('[name="purchaseDate"]'),
      productInput: form.querySelector('[name="productName"]'),
      skuInput: form.querySelector('[name="productSku"]'),
      verifiedInput: verifiedInput,
      orderIdInput: orderIdInput,
      productField: root.querySelector("[data-product-field]"),
      statusEl: statusEl,
    };
    if (!ui || !btn || !orderInput || !emailInput) return;

    // Only reveal the lookup UI if the backend actually has it configured.
    fetch(apiBase + "/api/order-lookup", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && data.available) ui.hidden = false; })
      .catch(function () {});

    function resetVerification() {
      if (verifiedInput) verifiedInput.value = "";
      if (orderIdInput) orderIdInput.value = "";
      orderInput.removeAttribute("data-verified");
      var picker = els.productField && els.productField.querySelector("[data-injected]");
      if (picker) picker.parentNode.removeChild(picker);
      setLookupStatus(statusEl, "", "");
    }
    orderInput.addEventListener("input", resetVerification);
    emailInput.addEventListener("input", resetVerification);

    btn.addEventListener("click", function () {
      var orderNumber = (orderInput.value || "").trim();
      var email = (emailInput.value || "").trim();
      if (!email) { setLookupStatus(statusEl, "error", "Enter your email above first."); emailInput.focus(); return; }
      if (!orderNumber) { setLookupStatus(statusEl, "error", "Enter your order number first."); orderInput.focus(); return; }

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Checking…";
      setLookupStatus(statusEl, "info", "Looking up your order…");

      fetch(apiBase + "/api/order-lookup", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ orderNumber: orderNumber, email: email }),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          btn.disabled = false;
          btn.textContent = original;
          if (res && res.ok && res.order) {
            applyVerifiedOrder(res.order, els);
          } else {
            setLookupStatus(statusEl, "error", (res && res.message) || "We couldn't verify that order. You can enter your details manually.");
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = original;
          setLookupStatus(statusEl, "error", "We couldn't reach the order system. You can enter your details manually.");
        });
    });
  }

  function applyVerifiedOrder(order, els) {
    if (els.orderInput && order.orderNumber) els.orderInput.value = order.orderNumber;
    if (els.dateInput && order.purchaseDate) els.dateInput.value = order.purchaseDate;
    if (els.orderIdInput) els.orderIdInput.value = order.shopifyOrderId || "";
    if (els.verifiedInput) els.verifiedInput.value = "true";
    if (els.orderInput) els.orderInput.setAttribute("data-verified", "1");

    var products = order.products || [];
    renderProductPicker(els.productField, products, els.productInput, els.skuInput);

    var msg = "✓ Order " + (order.orderNumber || "") + " verified.";
    if (products.length === 1) msg += " We filled in your product and purchase date.";
    else if (products.length > 1) msg += " Choose which item your claim is about below.";
    else msg += " We filled in your purchase date.";
    setLookupStatus(els.statusEl, "success", msg);
  }

  function renderProductPicker(productField, products, productInput, skuInput) {
    if (!productField) return;
    var existing = productField.querySelector("[data-injected]");
    if (existing) existing.parentNode.removeChild(existing);
    if (!products.length) return;

    function fill(p) {
      if (productInput) productInput.value = p.name || "";
      if (skuInput && p.sku) skuInput.value = p.sku;
    }

    // Single item: fill the existing fields directly, no picker needed.
    if (products.length === 1) {
      fill(products[0]);
      return;
    }

    var wrap = document.createElement("div");
    wrap.className = "warranty-tool__product-picker";
    wrap.setAttribute("data-injected", "1");
    var label = document.createElement("label");
    label.textContent = "Which item is this about?";
    var select = document.createElement("select");
    var first = document.createElement("option");
    first.value = "";
    first.textContent = "Select the item…";
    select.appendChild(first);
    products.forEach(function (p, i) {
      var opt = document.createElement("option");
      opt.value = String(i);
      opt.textContent = p.name + (p.sku ? " (" + p.sku + ")" : "");
      select.appendChild(opt);
    });
    select.addEventListener("change", function () {
      var idx = parseInt(select.value, 10);
      if (!isNaN(idx) && products[idx]) fill(products[idx]);
    });
    wrap.appendChild(label);
    wrap.appendChild(select);
    productField.insertBefore(wrap, productField.firstChild);
  }

  function setLookupStatus(el, kind, text) {
    if (!el) return;
    el.className = "warranty-tool__lookup-status" + (kind ? " is-" + kind : "");
    el.textContent = text || "";
  }

  function submit(apiBase, root, form, messageEl, submitBtn) {
    clearFieldErrors(form);
    hideMessage(messageEl);
    setBusy(submitBtn, true, "Submitting…");

    var fd = new FormData(form);

    fetch(apiBase + "/api/warranty-requests", { method: "POST", body: fd })
      .then(function (r) {
        return r.json().then(function (body) {
          return { status: r.status, body: body };
        });
      })
      .then(function (res) {
        if (res.status === 201 && res.body && res.body.ok) {
          showSuccess(apiBase, root, form, messageEl, res.body.id);
          return;
        }
        setBusy(submitBtn, false, "Submit request");
        if (res.body && res.body.issues && res.body.issues.length) {
          applyFieldErrors(form, res.body.issues);
        }
        showMessage(messageEl, "error", (res.body && res.body.error) || "Something went wrong. Please check the form and try again.");
      })
      .catch(function () {
        setBusy(submitBtn, false, "Submit request");
        showMessage(messageEl, "error", "We couldn't submit your request. Please check your connection and try again.");
      });
  }

  function showSuccess(apiBase, root, form, messageEl, id) {
    var successMsg = root.getAttribute("data-success-message") || "Thanks! Your request has been received.";
    form.querySelectorAll("input, select, textarea, button").forEach(function (el) {
      el.disabled = true;
    });
    form.style.display = "none";
    showMessage(messageEl, "success", successMsg + " Reference: " + id);
    pollStatus(apiBase, id, messageEl, successMsg, 0);
  }

  function pollStatus(apiBase, id, messageEl, successMsg, tries) {
    if (tries > 6) return;
    setTimeout(function () {
      fetch(apiBase + "/api/warranty-requests/" + encodeURIComponent(id))
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (rec) {
          if (!rec) return;
          if (rec.status === "submitted" || rec.status === "needs_review") {
            var ref = rec.manufacturerReference || id;
            showMessage(messageEl, "success", "Submitted to " + rec.brand + "! Reference: " + ref);
            return;
          }
          if (rec.status === "failed") {
            showMessage(messageEl, "success", successMsg + " Our team will complete the submission for you. Reference: " + id);
            return;
          }
          showMessage(messageEl, "info", "Submitting your claim to the manufacturer… Reference: " + id);
          pollStatus(apiBase, id, messageEl, successMsg, tries + 1);
        })
        .catch(function () {});
    }, tries === 0 ? 1500 : 4000);
  }

  function applyFieldErrors(form, issues) {
    issues.forEach(function (issue) {
      var el = form.querySelector('[name="' + issue.field + '"]');
      if (el) {
        el.setAttribute("aria-invalid", "true");
        var field = el.closest(".warranty-tool__field");
        if (field) {
          var note = document.createElement("small");
          note.className = "warranty-tool__error";
          note.textContent = issue.message;
          field.appendChild(note);
        }
      }
    });
  }

  function clearFieldErrors(form) {
    form.querySelectorAll(".warranty-tool__error").forEach(function (n) {
      n.remove();
    });
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (n) {
      n.removeAttribute("aria-invalid");
    });
  }

  function setBusy(btn, busy, label) {
    if (!btn) return;
    btn.disabled = busy;
    btn.textContent = label;
  }

  function showMessage(el, kind, text) {
    if (!el) return;
    el.hidden = false;
    el.className = "warranty-tool__message is-" + kind;
    el.textContent = text;
  }

  function hideMessage(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = "";
  }

  function initAll() {
    document.querySelectorAll("[data-warranty-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when a section is added/reloaded.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-warranty-root]");
    if (root) initRoot(root);
  });
})();
